export default {
  config: {}
};
